export class SerpConfig {
  constructor(
    public useGatherEventsInCityBeforeStop: boolean,
    public gatherNumberOfEventsInCityBeforeStop: number,
    public maxTryingPages: number,
    public isTest: boolean,
    public type: 'city' | 'keywords' = 'city', // there are 2 types of Serp pulling, "city" means input a city name, and pull events in the city. "keywords" means input any searching phrase to pull events
    public keywords?: string // type: "keywords")
  ) {}
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/models/admin/serp.config.ts